import React from 'react';
import './CustomSectionCard.scss';

const CustomSectionCard = ({ title, subtitle, children, className = "" }) => {
  return (
    <div className={`custom-section-container ${className}`}>
      {(title || subtitle) && (
        <div className="custom-section-header">
          {title && <h2 className="custom-title">{title}</h2>}
          {subtitle && <p className="custom-subtitle">{subtitle}</p>}
        </div>
      )}
      <div className="custom-section-body">
        {children}
      </div>
    </div>
  );
};

export default CustomSectionCard;